import styled, { createGlobalStyle, keyframes } from 'styled-components'

const login = {
  navy: '#0c1a3f',
  primary: '#1b3f96',
  primaryHover: '#16336f',
  cyan: '#22a7e0',
  accent: '#f6a91b',
  border: '#d8dde9',
  label: '#33405c',
  placeholder: '#9aa3b8',
  body: "'DM Sans', 'Open Sans', system-ui, sans-serif",
  display: "'Outfit', 'Open Sans', sans-serif"
}

const driftA = keyframes`
  0% {
    transform: translate3d(-14%, -10%, 0) scale(0.9);
  }
  50% {
    transform: translate3d(26%, 20%, 0) scale(1.4);
  }
  100% {
    transform: translate3d(-14%, -10%, 0) scale(0.9);
  }
`

const driftB = keyframes`
  0% {
    transform: translate3d(20%, 22%, 0) scale(1.25);
  }
  50% {
    transform: translate3d(-24%, -16%, 0) scale(0.92);
  }
  100% {
    transform: translate3d(20%, 22%, 0) scale(1.25);
  }
`

const driftC = keyframes`
  0% {
    transform: translate3d(-8%, 16%, 0) scale(0.95);
    opacity: 0.4;
  }
  50% {
    transform: translate3d(18%, -22%, 0) scale(1.45);
    opacity: 1;
  }
  100% {
    transform: translate3d(-8%, 16%, 0) scale(0.95);
    opacity: 0.4;
  }
`

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: stretch;
  flex-direction: row;
  font-family: ${login.body};
  section {
    flex: 1;
    min-height: 100vh;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 56px;
  }
  .form-group {
    margin-bottom: 0 !important;
  }
  .form-label {
    font-size: 13px;
    font-weight: 500;
    color: ${login.label};
    margin-bottom: 7px;
  }
  .form-control {
    height: 54px;
    padding: 0 16px;
    border-radius: 10px;
    border: 1px solid ${login.border};
    background: #fff;
    color: ${login.navy};
    font-family: ${login.body};
    font-size: 15px;
    box-shadow: none;
    transition: border-color 0.15s, box-shadow 0.15s;
    &::placeholder {
      color: ${login.placeholder};
    }
    &:focus {
      background: #fff;
      color: ${login.navy};
      border-color: ${login.primary};
      box-shadow: 0 0 0 4px rgba(27, 63, 150, 0.12);
    }
    &:disabled,
    &:read-only {
      background: #f4f6fb;
      color: ${login.label};
    }
  }
  .card {
    border-radius: 10px;
    border: 1px solid ${login.border};
    background: #f4f6fb;
    color: ${login.navy};
    font-size: 15px;
  }
  .btn {
    height: 56px;
    border-radius: 10px;
    font-family: ${login.display};
    font-size: 17px;
    font-weight: 600;
    box-shadow: none;
    transition: background-color 0.15s, border-color 0.15s, color 0.15s,
      transform 0.12s;
  }
  .btn-primary {
    background-color: ${login.primary};
    border-color: ${login.primary};
    &:hover,
    &:focus,
    &:active {
      background-color: ${login.primaryHover};
      border-color: ${login.primaryHover};
    }
    &:active {
      transform: translateY(1px);
    }
    &:disabled {
      background-color: ${login.primary};
      border-color: ${login.primary};
      opacity: 0.4;
    }
  }
  .btn-outline-primary {
    background-color: transparent;
    border-color: ${login.border};
    color: ${login.primary};
    &:hover,
    &:focus,
    &:active {
      background-color: rgba(27, 63, 150, 0.06);
      border-color: ${login.primary};
      color: ${login.primary};
    }
    &:disabled {
      opacity: 0.4;
    }
  }
  .btn-link {
    height: auto;
    padding: 0;
    font-family: ${login.body};
    font-size: 14px;
    font-weight: 500;
    color: ${login.primary};
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${login.cyan};
      text-decoration: none;
    }
  }
  .form-text {
    font-family: ${login.body};
    font-size: 12px;
  }
  @media screen and (max-width: 991px) {
    flex-direction: column;
    section {
      min-height: auto;
      padding: 40px 24px 56px;
    }
  }
`

export const Brand = styled.aside`
  width: 55%;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  padding: 64px 56px;
  background: ${login.navy};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .brand-aurora {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    pointer-events: none;
  }
  [data-ocix-glow] {
    position: absolute;
    border-radius: 50%;
  }
  [data-ocix-glow='a'] {
    top: -26%;
    left: -22%;
    width: 900px;
    height: 900px;
    background: radial-gradient(
      circle,
      rgba(34, 167, 224, 0.72),
      rgba(34, 167, 224, 0) 64%
    );
    filter: blur(26px);
    animation: ${driftA} 18s ease-in-out infinite;
  }
  [data-ocix-glow='b'] {
    top: 14%;
    right: -30%;
    width: 860px;
    height: 860px;
    background: radial-gradient(
      circle,
      rgba(48, 100, 220, 0.95),
      rgba(27, 63, 150, 0) 66%
    );
    filter: blur(30px);
    animation: ${driftB} 24s ease-in-out infinite;
  }
  [data-ocix-glow='c'] {
    bottom: -34%;
    left: 12%;
    width: 780px;
    height: 780px;
    background: radial-gradient(
      circle,
      rgba(34, 167, 224, 0.58),
      rgba(34, 167, 224, 0) 66%
    );
    filter: blur(34px);
    animation: ${driftC} 15s ease-in-out infinite;
  }
  .brand-grain {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* grão de ruído; a URL vai 100% percent-encoded porque o stylis lê o
       '//' de 'http://' como início de comentário e engole o resto da regra */
    background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22160%22%20height%3D%22160%22%3E%3Cfilter%20id%3D%22n%22%3E%3CfeTurbulence%20type%3D%22fractalNoise%22%20baseFrequency%3D%220.85%22%20numOctaves%3D%223%22%2F%3E%3C%2Ffilter%3E%3Crect%20width%3D%22160%22%20height%3D%22160%22%20filter%3D%22url%28%23n%29%22%20opacity%3D%220.5%22%2F%3E%3C%2Fsvg%3E');
    opacity: 0.09;
    mix-blend-mode: overlay;
  }
  @media (prefers-reduced-motion: reduce) {
    [data-ocix-glow] {
      animation: none !important;
    }
  }
  &::after {
    content: '';
    position: absolute;
    right: -130px;
    bottom: -110px;
    width: 560px;
    height: 448px;
    background: url('/logo-ocix-marca.svg') no-repeat center / contain;
    opacity: 0.12;
    pointer-events: none;
  }
  .brand-logo {
    position: relative;
    z-index: 2;
    width: 260px;
    height: auto;
  }
  .brand-copy {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 28px;
    max-width: 460px;
    margin: 64px 0;
  }
  h1 {
    font-family: ${login.display};
    font-size: 60px;
    font-weight: 600;
    line-height: 0.98;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0;
  }
  .brand-tagline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
    font-family: ${login.display};
    font-size: 25px;
    font-weight: 600;
    color: ${login.navy};
    span {
      background: ${login.accent};
      padding: 4px 12px 6px;
    }
  }
  .brand-signature {
    position: relative;
    z-index: 2;
    margin: 0;
    font-family: ui-monospace, monospace;
    font-size: 11px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.45);
  }
  @media screen and (max-width: 991px) {
    width: 100%;
    padding: 40px 28px;
    &::after {
      right: -170px;
      bottom: -150px;
      width: 380px;
      height: 304px;
    }
    .brand-logo {
      width: 190px;
    }
    .brand-copy {
      gap: 20px;
      margin: 32px 0;
    }
    h1 {
      font-size: 40px;
    }
    .brand-tagline {
      font-size: 19px;
    }
    .brand-signature {
      display: none;
    }
  }
`

export const Box = styled.form`
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: none;
  }
  small {
    display: block;
    font-size: 12px;
    color: ${login.placeholder};
    margin-top: 1rem;
  }
  @media screen and (max-width: 600px) {
    flex: 1;
    max-width: 100%;
  }
`

export const LogoBox = styled.header`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 30px;
  font-family: ${login.display};
  font-size: 32px;
  font-weight: 600;
  line-height: 1.08;
  letter-spacing: -0.01em;
  text-align: left;
  color: ${login.navy};
  &::before {
    content: '';
    flex: 0 0 34px;
    width: 34px;
    height: 28px;
    margin-top: 4px;
    background: url('/logo-ocix-marca.svg') no-repeat center / contain;
    filter: brightness(0.35) saturate(1.4);
  }
`

export const ContentInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  > header {
    margin-bottom: 12px;
  }
`

/*
 * Esconde o selo flutuante do reCAPTCHA v3.
 *
 * Precisa ser estilo GLOBAL, e não uma regra aninhada em `Container`: o script
 * do Google pendura o `.grecaptcha-badge` direto no `document.body`, fora da
 * árvore da tela, então qualquer seletor descendente a partir daqui não
 * casaria com ele.
 *
 * O recorte "só na tela de autenticação" vem do ciclo de vida: este componente
 * é renderizado apenas dentro da AuthPage, e o styled-components remove a
 * folha de estilo no unmount. Fora do login a regra deixa de existir.
 *
 * `visibility: hidden` (e não `display: none`) é o que o Google documenta como
 * aceitável, e só é permitido porque a atribuição abaixo fica visível na tela.
 */
export const HideRecaptchaBadge = createGlobalStyle`
  .grecaptcha-badge {
    visibility: hidden;
  }
`

/**
 * Atribuição exigida pelos termos do reCAPTCHA quando o selo está oculto.
 * Some junto com o selo: sem captcha configurado, nada disso é renderizado.
 */
export const RecaptchaNotice = styled.small`
  display: block;
  margin-top: 14px;
  font-size: 11px;
  line-height: 1.45;
  color: ${login.placeholder};
  text-align: center;
  a {
    color: ${login.primary};
    text-decoration: underline;
  }
`

/**
 * Moldura do QR Code da vinculação do autenticador.
 *
 * Fundo branco explícito e padding: o QR precisa de "quiet zone" clara em
 * volta para que a câmera o encontre, e o `margin: 1` passado à biblioteca é
 * estreito demais sozinho.
 */
export const MfaQrBox = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border: 1px solid ${login.border};
  border-radius: 12px;
  background: #fff;
`

/**
 * Segredo TOTP em texto, para quem não consegue escanear o QR.
 *
 * Monoespaçado e com `letter-spacing`: o alfabeto base32 tem 0/O e 1/I, e a
 * pessoa está copiando caractere a caractere para o celular. `user-select:
 * all` faz um clique selecionar o segredo inteiro, sem arrastar.
 */
export const MfaSecret = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  border: 1px dashed ${login.border};
  border-radius: 10px;
  background: #f4f6fb;
  text-align: center;
  .mfa-secret-label {
    font-family: ${login.body};
    font-size: 12px;
    color: ${login.placeholder};
  }
  code {
    font-family: ui-monospace, 'SFMono-Regular', Menlo, monospace;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.08em;
    color: ${login.navy};
    word-break: break-all;
    user-select: all;
  }
`

/**
 * Aviso do segundo fator por e-mail: para onde o código foi e que NÃO existe
 * reenvio.
 *
 * Visual deliberadamente informativo (azul) e não de alerta: no modo e-mail
 * nada deu errado, a pessoa só precisa saber que o caminho para um código novo
 * é refazer o login, e não um botão de reenviar — que não existe porque a API
 * não tem endpoint de resend.
 */
export const MfaEmailNotice = styled.div`
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid ${login.border};
  border-left: 3px solid ${login.navy};
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: ${login.label};
  background: #f4f6fb;
  text-align: left;
  strong {
    color: ${login.navy};
    /* O e-mail é longo e vai dentro de uma caixa estreita. */
    word-break: break-word;
  }
`

/** Aviso de penalidade por excesso de tentativas, com o contador regressivo. */
export const ThrottleNotice = styled.div`
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid ${login.border};
  border-left: 3px solid ${login.accent};
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: ${login.label};
  background: #fdf8ec;
`
